import { utils } from '@yola/webapp-plugins';
import { constants, selectors } from '@yola/subscription-manager-js';
import { integration } from '@yola/ws-sdk';
import bowser from 'yola-bowser';
import store from 'src/js/store';
import { DEFAULT } from '../constants/upsell-types';

const { getDifmBannerSessionStorageValue } = utils;

const {
  SubscriptionType: { B2C_HOSTING_GOLD },
} = constants;

const isDifmOfferBannerVisible = (premiumFeature) => {
  const state = store.getState();
  const userId = integration.selectors.getUserId(state);
  const isTouchDevice = bowser.mobile || bowser.tablet;

  const currentPlan = selectors.getCurrentPackageType(state);
  const isDefaultPremiumFeature = premiumFeature === DEFAULT;
  const difmBannerSessionStorageValue = getDifmBannerSessionStorageValue();
  const isDifmBannerVisible = difmBannerSessionStorageValue !== userId;

  return (
    isDifmBannerVisible &&
    isDefaultPremiumFeature &&
    currentPlan !== B2C_HOSTING_GOLD &&
    !isTouchDevice
  );
};

export default isDifmOfferBannerVisible;
